<template>
  <div>
    <v-card
      class="d-flex flex-column justify-center align-center pa-4 pb-6"
      elevation="0"
    >
      <img :src="logoUrl" style="width: 25px" />
      <v-form v-model="form" class="px-4" @submit.prevent="signupSubmit">
        <h2 class="my-4 mt-6 text-left">Create your account</h2>
        <v-text-field
          v-model="email"
          name="E-Mail Address"
          label="E-Mail Address"
          :rules="emailRules"
          background-color="grey lighten-3"
          solo
          dense
          flat
          required
        ></v-text-field>
        <v-text-field
          v-model="username"
          name="Username"
          label="Username"
          :rules="usernameRules"
          background-color="grey lighten-3"
          solo
          dense
          flat
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          name="Password"
          label="Password"
          type="password"
          :rules="passwordRules"
          background-color="grey lighten-3"
          solo
          dense
          flat
          required
        ></v-text-field>
        <v-text-field
          v-model="phone"
          name="Phone Number"
          label="Phone Number"
          :rules="phMobileRules"
          background-color="grey lighten-3"
          solo
          dense
          flat
          required
        ></v-text-field>

        <v-checkbox v-model="agreeTerms" :rules="termsRules" class="mt-0">
          <template v-slot:label>
            <p>
              I agree to the
              <a @click="openTermsAndConditions"> Terms and Conditions </a>
              and
              <a @click="openPrivacyPolicy"> Privacy Policy </a>
            </p>
          </template>
        </v-checkbox>

        <p class="body-1">I am a...</p>
        <v-radio-group v-model="managerAccount" class="mt-0">
          <v-radio label="Property Manager" value="lessor"></v-radio>
          <v-radio label="Tenant" value="tenant"></v-radio>
        </v-radio-group>

        <v-card-actions class="justify-end">
          <v-btn rounded depressed small @click="hideSignup"> Back </v-btn>
          <v-btn
            rounded
            depressed
            color="primary"
            :disabled="!agreeTerms || !form"
            type="loginSubmit"
            small
          >
            Sign Up
          </v-btn>
        </v-card-actions>
        <!-- <input type="email" placeholder="E-Mail" v-model="email">
        <input type="password" placeholder="Password" v-model="password"> -->
        <!-- <button type="submit">Login</button> -->
      </v-form>
    </v-card>
    <TermsAndConditions ref="termsAndConditions"></TermsAndConditions>
    <PrivacyPolicy ref="privacyPolicy"></PrivacyPolicy>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackMessage }}
      <v-btn color="primary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TermsAndConditions from '../usage/TermsAndConditions.vue'
import PrivacyPolicy from '../usage/PrivacyPolicy.vue'

export default {
  components: {
    TermsAndConditions,
    PrivacyPolicy
  },
  data() {
    return {
      username: '',
      password: '',
      email: '',
      phone: '',
      managerAccount: 'lessor',
      version: process.env.VUE_APP_VERSION,
      snackMessage: '',
      snackbar: false,
      timeout: 5000,
      emailRules: [
        (v) => validateEmail(v) || 'E-Mail must be a valid e-mail format'
      ],
      usernameRules: [
        (v) => v.length >= 5 || 'Username must be 5 characters or longer'
      ],
      passwordRules: [
        (v) => !!v || 'Password is Required',
        (v) => {
          const pattern = /(?=.*\d)(?=.*[A-Za-z])/
          return (
            pattern.test(v) ||
            'Password must contain at least one number and letter'
          )
        },
        (v) => v.length >= 8 || 'Password must contain at least 8 characters'
      ],
      termsRules: [
        (v) => v == true || 'You must agree to the Terms and Conditions'
      ],
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        }
      ],
      agreeTerms: false,
      form: false,
      loading: false
    }
  },
  computed: {
    ...mapState('auth', ['loggingIn', 'loginError', 'loginSuccessful']),
    logoUrl() {
      return `${process.env.BASE_URL}images/logo.png`
    }
  },
  methods: {
    ...mapActions('auth', ['doSignup', 'doLogin']),
    hideSignup() {
      this.$emit('hideSignup')
    },
    async signupSubmit() {
      this.loading = true
      if (validateEmail(this.email)) {
        return this.doSignup({
          email1: this.email,
          username: this.username,
          password: this.password,
          userType: this.managerAccount,
          contactNumber1: this.phone
        }).then((response) => {
          this.loading = false
          if (response.success) {
            this.loginSubmit()
            // this.$router.replace('/dashboard')
          } else {
            this.snackbar = true
            this.snackMessage = response.message
          }
        })
      } else {
        this.snackbar = true
        this.snackMessage = 'Please provide a valid email address.'
      }
    },
    loginSubmit() {
      return this.doLogin({
        username: this.username,
        password: this.password
      }).then((response) => {
        if (response) {
          // this.$router.go()
          window.location.reload()
          // this.$router.replace('/dashboard')
        }
      })
    },
    openTermsAndConditions() {
      this.$refs.termsAndConditions.open()
    },
    openPrivacyPolicy() {
      this.$refs.privacyPolicy.open()
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.$router.replace('/login')
    }
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase())
}
</script>

<style scoped>
.v-card {
  border-radius: 12px !important;
}
.v-menu__content {
  border-radius: 20px !important;
}
p {
  margin-bottom: 0;
}
.link {
  padding-top: 20px;
  text-align: center;
}
.link a {
  text-decoration: none;
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
}
.subtitle-2 {
  letter-spacing: 3px;
}
</style>
